import * as Sentry from '@sentry/browser';
import { CertificationsQueryQuery, CertificationsQueryQueryVariables, type Certification } from '__generated__/graphql';
import { useToastOpen } from 'contexts/ToastContext';
import gql from 'graphql-tag';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { t } from 'utils/localize';

export const certificationsQuery = gql`
  query CertificationsQuery($filter: CertificationFilter, $after: String, $first: Int, $sort: [CertificationSort!]) {
    certifications(filter: $filter, first: $first, after: $after, sort: $sort) {
      id
      organizationId
      name
      description
      renewalPeriodMonths
      employeeManaged
      documentationRequired
      createdOn
      submittedOn
      updatedOn
      deletedOn
      cursor
    }
  }
`;

export function useCertificationRequest() {
  const graphqlClient = useGraphQLClient();
  const toastOpen = useToastOpen();

  return (variables: CertificationsQueryQueryVariables): Promise<Certification[]> => {
    const requestConfig = { document: certificationsQuery, variables };

    return graphqlClient
      .request<CertificationsQueryQuery, CertificationsQueryQueryVariables>(requestConfig)
      .then((result) => result.certifications ?? [])
      .catch((error: unknown) => {
        toastOpen({ label: t('Failed to load Certifications.') });
        Sentry.captureException(error, { extra: { requestConfig, variables } });
        // eslint-disable-next-line no-console
        console.error('Error fetching Certifications:', { error, requestConfig });

        return [];
      });
  };
}
